import * as Diagram from "../../../../components/diagram";

export const ClosedCaseServiceEffectivenessAnalysis = {
  label: "服務成效分析(結案)",
  key: "ClosedCaseServiceEffectivenessAnalysis",
  path: "PsychologicalCounseling/ClosedCaseServiceEffectivenessAnalysis",
  api: "TCS_V_PsychologicalCounseling_4",
  render: (options) => (
    <Diagram.PsychologicalCounseling.ClosedCaseServiceEffectivenessAnalysis
      {...options}
    />
  ),
  isRaw: true,
  isPage: true,
  page: null,
  dateRangeColumns: [{ label: "開案日期", key: "開案日期" }],
  columns: [
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "身分證字號",
      field: "身分證字號",
      header: "身分證字號",
    },
    {
      key: "性別",
      field: "性別",
      header: "性別",
    },
    {
      key: "生日",
      field: "生日",
      header: "生日",
    },
    {
      key: "連絡電話",
      field: "連絡電話",
      header: "連絡電話",
    },
    {
      key: "行動電話",
      field: "行動電話",
      header: "行動電話",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "年齡",
      field: "年齡",
      header: "年齡",
    },
    {
      key: "個案來源",
      field: "個案來源",
      header: "個案來源",
    },
    {
      key: "開案日期",
      field: "開案日期",
      header: "開案日期",
    },
    {
      key: "F-BSR-5",
      field: "F-BSR-5",
      header: "F-BSR-5",
    },
    {
      key: "F-自殺",
      field: "F-自殺",
      header: "F-自殺",
    },
    {
      key: "F-GDS-15",
      field: "F-GDS-15",
      header: "F-GDS-15",
    },
    {
      key: "L-BSR-5",
      field: "L-BSR-5",
      header: "L-BSR-5",
    },
    {
      key: "L-自殺",
      field: "L-自殺",
      header: "L-自殺",
    },
    {
      key: "L-GDS-15",
      field: "L-GDS-15",
      header: "L-GDS-15",
    },
  ],
};
